import {Alert, Box, Button, Grid, Paper, Snackbar, TextField} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {useUserActions} from "../service/user.actions";
import {useFormik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from 'yup';
import {string} from 'yup';
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import CustomLoader from "../../../util/component/CustomLoader";
import * as React from "react";

interface Values {
    username: string;
    password: string;
}

const LoginPage = () => {
    const {globalData} = useContext(GlobalContext);
    const userActions = useUserActions();
    const navigate = useNavigate();
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (globalData.user) navigate("/");
    }, []);

    const validationSchema = yup.object({
        username: string().required('Username is required'),
        password: string().min(4, 'Password should be of minimum 4 characters length')
            .required('Password is required'),
    });

    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values: Values) => {
            setIsLoading(true);
            return userActions.login(values.username, values.password)
                .catch(error => {
                    setShowErrorAlert(true);
                }).finally(() => {
                    setIsLoading(false)
                });
        },
    });

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
        }}>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Paper sx={{padding: 2, backgroundColor: '#ffffff', width:'80vw'}} elevation={1}>
                        <Grid item xs={12} mb={2} >
                            <img alt="logo" src={"/images/logo-black.svg"} width={'150px'}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="username"
                                name="username"
                                label="Username"
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                error={formik.touched.username && Boolean(formik.errors.username)}
                                helperText={formik.touched.username && formik.errors.username}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type={"password"}
                                id="password"
                                name="password"
                                label="Password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                            />
                        </Grid>
                        <Grid item xs={12} mt={2}>
                            <Button fullWidth type={"submit"}>Login</Button>
                        </Grid>
                    </Paper>
                </Grid>
            </form>
            <Snackbar open={showErrorAlert} autoHideDuration={6000} onClose={() => {
                setShowErrorAlert(false)
            }}
                      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                id={'login-snackbar'}
            >
                <Alert onClose={() => {
                    setShowErrorAlert(false)
                }} severity="error" sx={{width: '100%'}}>
                    Credenziali errate
                </Alert>
            </Snackbar>
            <CustomLoader loading={isLoading}/>
        </Box>
    );
}

export default LoginPage;
